export const GRN_IMAGE_BASE = "https://images.grnconnect.com";
export const HOTEL_FALLBACK_IMAGE = "/images/1.jpg";

const ABSOLUTE_URL_REGEX = /^https?:\/\//i;

export const buildHotelImageUrl = (imagePath?: string | null) => {
  const normalizedPath = imagePath?.trim();

  if (!normalizedPath) {
    return HOTEL_FALLBACK_IMAGE;
  }

  if (ABSOLUTE_URL_REGEX.test(normalizedPath)) {
    return normalizedPath;
  }

  return `${GRN_IMAGE_BASE}/${normalizedPath.replace(/^\/+/, "")}`;
};

export const dedupeHotelImages = (urls: string[]) =>
  Array.from(new Set(urls.filter(Boolean)));
